export class VoiceCommand{
    id!: number;
    command!:string;
    secondCommand!:string;
    inPage!:string;
    action!:string;
    destination!:string;
}